import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DeleteDataService {
  constructor(private http: HttpClient) {}
  /////// NUEVOS SERVICIOS DAE /////
  ///ELIMINAR DOCUMENTOS
  deleteDocuments(
    countryCode: string,
    applicationId: string,
    fileName: string
  ) {
    return this.http.delete(
      `${
        environment.apiurl
      }/countries/${countryCode}/applications/${applicationId}/documents/${this.convertToBase64(
        fileName
      )}`
    );
  }
  ///ELIMINAR DOCUMENTOS
  deleteDocumentsCo(
    countryCode: string,
    applicationId: string,
    fileName: string
  ) {
    return this.http.delete(
      `${
        environment.apiUrlCo
      }/countries/${countryCode}/applications/${applicationId}/documents/${this.convertToBase64(
        fileName
      )}`
    );
  }

  convertToBase64(text: string) {
    return btoa(
      encodeURIComponent(text).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
      })
    );
  }

  //// NUEVO FLUJO LTO ////
  ///ELIMINAR DOCUMENTOS
  deleteDocumentsLto(
    countryCode: string,
    applicationId: string,
    fileName: string
  ) {
    return this.http.delete(
      `${
        environment.apiUrlLto
      }/countries/${countryCode}/applications/${applicationId}/documents/${this.convertToBase64(
        fileName
      )}`
    );
  }
}
